$.post('/productAll',function(data) {
    window.products=data;
   // console.log(data);
});
$("#filterCat").change(function (e) {
    const elmActive=$('.js-catName'+$(this).val());
    const elmA=document.querySelector(".js-catName.active");
    elmA.classList.remove("active");
    $( elmActive ).toggleClass( "active", "active" );
    $.post('/productPage',{
        page:1,
        id:$(this).val(),
    },function(data) {
        if(data ==''){
            $(".js-rowTwo").html('<h6>No hay mas productos</h6>');
        }else{
            $(".js-rowTwo").html(data);
            //filtersubcat
            $("#filterSubCat").change(function (e) {
                $(".subcategoria").removeClass( "activeSub");
                $(".subcategoria" + $(this).val()).addClass( "activeSub");
                $('.js-catName.active').attr('data-page','1');
                $.post('/productPageSubcategory',{
                    page:1,
                    sub_category_id: $(this).val(),
                    category_id: $("#filterSubCat").attr('id-cat')
                },function(data) {
                    if(data ==''){
                        $(".js-rowTwo").html('<h6>No hay mas productos</h6>');
                    }else{
                        $(".js-rowTwo").html(data);
                        clickSub();
                    }
                    $(".js-cotizar").click(function (e) {
                        addProductQuote(this.dataset.id);
                    });
                });
            });
            //endfiltersubcat
        }
        $(".js-cotizar").click(function (e) {
            addProductQuote(this.dataset.id);
        });
    });
});
$(".js-catName ").click(function (e) {
    const elmActive=this.querySelector(".js-catName");
    const elmA=document.querySelector(".js-catName.active");
    elmA.classList.remove("active");
    elmA.dataset.page=1;
    $(".js-catName"+this.dataset.id).addClass("active");
    const page=this.dataset.page;
    const id=this.dataset.id;

    $.post('/productPage',{
        page:page,
        id:id,
        id_sub: 0,
    },function(data) {
        if(data ==''){
            $(".js-rowTwo").html('<h6>No hay mas productos</h6>');
        }else{
            $(".js-rowTwo").html(data);
            clickSub();
        }
        $(".js-cotizar").click(function (e) {
            addProductQuote(this.dataset.id);
        });
    })
    .fail(function(error) {
        console.log(error);
    });
});
clickSub();
function clickSub() {
    $(".js-active2").click(function (e) {
        const idcat=this.dataset.idcat;
        const idsubcat=this.dataset.idsubcat;
        const page=this.dataset.page;
        $(".subcategoria").removeClass( "activeSub");
        $(".subcategoria" + idsubcat).addClass( "activeSub");
        $('.js-catName.active').attr('data-page','1');
        $.post('/productPageSubcategory',{
            page:page,
            sub_category_id: idsubcat,
            category_id: idcat
        },function(data) {
            if(data ==''){
                $(".js-rowTwo").html('<h6>No hay mas productos</h6>');
            }else{
                $(".js-rowTwo").html(data);
                clickSub();
            }
            $(".js-cotizar").click(function (e) {
                addProductQuote(this.dataset.id);
            });
        })
            .fail(function(error) {
                console.log(error);
            });
    });

    $("#filterSubCat").change(function (e) {
        //console.log('entro');
        $(".subcategoria").removeClass( "activeSub");
        $(".subcategoria" + $(this).val()).addClass( "activeSub");
        $('.js-catName.active').attr('data-page','1');
        $.post('/productPageSubcategory',{
            page:1,
            sub_category_id: $(this).val(),
            category_id: $(this).attr('id-cat')
        },function(data) {
            if(data ==''){
                $(".js-rowTwo").html('<h6>No hay mas productos</h6>');
            }else{
                $(".js-rowTwo").html(data);
                clickSub();
            }
            $(".js-cotizar").click(function (e) {
                addProductQuote(this.dataset.id);
            });
        });
    });

    if ($(window).width() > 600) {
        $(".js-arrowLeft, .js-arrowRight").click(function () {
            const elmActive=document.querySelector(".js-catName.active");
            let page=elmActive.dataset.page;
            const id=elmActive.dataset.id;
            const elmActive2=document.querySelector(".activeSub");
            const id_sub=elmActive2.dataset.idsubcat;
            //alert(id_sub);
            const arrowLR=this;
            if(arrowLR.classList.contains("js-arrowLeft")){
                page=parseInt(page)-1;
                elmActive.dataset.page=page;
            }else{
                page=parseInt(page)+1;
                elmActive.dataset.page=page;
            }
            setTimeout(function () {
                console.log(id_sub);
                $.post('/productPage',{
                    page:page,
                    id:id,
                    id_sub: id_sub,
                },function(data) {
                    if(data ==''){
                        $(".js-rowTwo").html('<h6>No hay mas productos</h6>');
                    }else{
                        $(".js-rowTwo").html(data);
                    }
                    $(".js-cotizar").click(function (e) {
                        addProductQuote(this.dataset.id);
                    });
                    $('html, body').animate({
                        scrollTop: $('#products').offset().top - 100
                    }, 500);
                    clickSub();
                });
            },200);
        });
    }
}

$(".js-arrowLeft, .js-arrowRight").click(function () {
    const elmActive=document.querySelector(".js-catName.active");
    let page=elmActive.dataset.page;
    const id=elmActive.dataset.id;
    const elmActive2=document.querySelector(".activeSub");
    const id_sub=elmActive2.dataset.idsubcat;
    //alert(id_sub);
    const arrowLR=this;
    if(arrowLR.classList.contains("js-arrowLeft")){
        page=parseInt(page)-1;
        elmActive.dataset.page=page;
    }else{
        page=parseInt(page)+1;
        elmActive.dataset.page=page;
    }
    setTimeout(function () {
        console.log(id_sub);
        $.post('/productPage',{
            page:page,
            id:id,
            id_sub: id_sub,
        },function(data) {
            if(data ==''){
                $(".js-rowTwo").html('<h6>No hay mas productos</h6>');
            }else{
                $(".js-rowTwo").html(data);
            }
            $(".js-cotizar").click(function (e) {
                addProductQuote(this.dataset.id);
            });
            $('html, body').animate({
                scrollTop: $('#products').offset().top - 100
            }, 500);
            clickSub();
        });
    },200);
});


//funciones para cotizar...

window.cotizar=[];
const productQuote=$($(".modalCotizar")[0].querySelector(".description"));
if(!localStorage.hasOwnProperty("cotizar")){
    localStorage["cotizar"]="0";
    localStorage["product"]="";
    localStorage["product_id"]="";
}else{
    productQuote.html(localStorage["product"]);
    $(".contador").text(localStorage["cotizar"]);
    window.cotizar=localStorage["product_id"].split(",");
    setTimeout(() => {
        actionQuote();
    }, 100);
}

$(".js-cotizar").click(function (e) {
    addProductQuote(this.dataset.id);
});

function addProductQuote(id_prod) {

    const cont = parseInt($($(".contador")[0]).text());
    cotizar.indexOf(id_prod)!=-1 ?
        swal({
            title: "Este producto, ya se agrego",
            text: "",
            icon: imageURL,
            button: "Aceptar",
        })
        :
        (()=>{
            window.cotizar.push(id_prod);
            if(localStorage["product_id"]==""){
                localStorage["product_id"]=id_prod;
            }else{
                localStorage["product_id"]=localStorage["product_id"]+","+id_prod;
            }

            const elemQuote=products[id_prod];
            $(".contador").text(cont+1);
            const divAddProd=$("<div>").addClass("row js-parentsElm delete-element"+elemQuote.id+"").appendTo(productQuote);
            divAddProd.html(
                '<div class="col s6 m4 l4">'+
                '<div class="img">'+
                '<div>'+
                '<img src="'+https+elemQuote.img+'" alt="">'+
                '</div>'+
                '</div>'+
                '</div>'+
                '<div class="col s6 m8 l8">'+
                '<h2>'+
                elemQuote.name+
                '</h2>'+
                '<h3>'+
                '<div class="row">'+
                '<div class="col s12 prod_col">'+
                '<span>'+
                'Categoría:'+
                '</span>'+
                '<div class="category-quote valign-wrapper">'+
                '<div class="col s12">'+
                elemQuote.category.name+
                '</div>'+
                '</div>'+
                '</div>'+
                '<div class="col s12 prod_col valign-wrapper">'+
                '<span>'+
                'Cantidad:'+
                '</span>'+
                '<div class="cant-quote center-align">'+
                '<div class="col s4">'+
                '<a class="icon-quote js-CantRemove">'+
                '<i class="material-icons">remove_circle</i>'+
                '</a>'+
                '</div>'+
                '<div class="col s4">'+
                '<input class="browser-default" type="text" name="cantQuote[]" id="cantQuote'+elemQuote.id+'" value="1">'+
                '<input class="browser-default" type="hidden" name="id[]" id="id" value="'+elemQuote.id+'">'+
                '</div>'+
                '<div class="col s4">'+
                '<a  class="icon-quote js-CantAdd" id="'+elemQuote.id+'">'+
                '<i class="material-icons">add_circle</i>'+
                '</a>'+
                '</div>'+
                '</div>'+
                '</div>'+
                '<i data-id="'+elemQuote.id+'" class="material-icons deleteElem js-deleteElem">delete</i>'+
                '</div>'+
                '</h3>'+
                '</div>'
            );
            setTimeout(() => {
                actionQuote();
                localStorage["cotizar"]=parseInt($($(".contador")[0]).text());
                localStorage["product"]=productQuote.html();
            }, 100);
        })();
}
function actionQuote() {
    $(document.querySelectorAll(".js-CantRemove")).click(function (e) {
        const cant=$($(this).parents(".cant-quote")[0].querySelector("input")).val();
            if(cant>1){
                $($(this).parents(".cant-quote")[0].querySelector("input")).val(parseInt(cant)-1);
            }
        console.log(cant);
        setTimeout(() => {
            localStorage["cotizar"]=parseInt($($(".contador")[0]).text());
            localStorage["product"]=productQuote.html();
        }, 100);
    });

    $(document.querySelectorAll(".js-CantAdd")).click(function (e) {
        const cant=$('#cantQuote'+this.id).val();
        if(cant>=1){
            $('#cantQuote'+this.id).val(parseInt(cant)+1);
        }
        console.log(cant);
        setTimeout(() => {
            localStorage["cotizar"]=parseInt($($(".contador")[0]).text());
            localStorage["product"]=productQuote.html();
        }, 100);
    });

    $(document.querySelectorAll(".js-deleteElem")).click(function (e) {
        //console.log(cotizar,this.dataset.id);
        const ind=cotizar.indexOf(this.dataset.id);
        if(ind!=-1){
            //console.log(cotizar.indexOf(this.dataset.id));
            cotizar.splice(ind,1);
            $('.delete-element'+this.dataset.id).remove();
            localStorage["product"]=productQuote.html();
            //productQuote.html(localStorage["product"]);
            /*const parentsElm=$(this).parents(".js-parentsElm")[0];
            if(parentsElm.parentNode){
                parentsElm.parentNode.remove(parentsElm);
                //localStorage["product"]=productQuote.html();
                //productQuote.html(localStorage["product"]);
            }
             */
            const ProC=parseInt($($(".contador")[0]).text());
            if(parseInt($($(".contador")[0]).text())!=0){
                $(".contador").text(ProC-1);
                localStorage["cotizar"]=ProC-1;
            }
            localStorage["product_id"] = cotizar;
        }else{
            //productQuote.html("");
            //cotizar=[];
        }
    });

}

$('.open-cotizar').click(function (e) {
    productQuote.html(localStorage["product"]);
    actionQuote();
    $('.modalCotizar').modal('open');
});


grecaptcha.ready(function() {
    grecaptcha.execute('6LfRdtwZAAAAAGAsZTr769WArVkDxPg3hV2MFeU7', {action: 'submit'}).then(function(token) {
        $('.formContacto #token').val(token);
        //$('.formContacto').prepend('<input type="hidden" name="token" value="' + token + '">');
        //$('.formContacto').submit();
    });
});

$(".js-btnQuote").click(function () {
    const inputName=document.querySelectorAll(".ContenerContacto input[name]");
    new Promise((resolve, reject) => {
        let ft=false;
        for (let index = 0; index < inputName.length; index++) {
            const element = inputName[index];
            if(element.value.trim()==""){
                $(element).addClass("error");
                ft=true;
            }else{
                $(element).removeClass("error");
            }

        }
        resolve(ft);
    }).then(function (ft) {
        if(ft==true){
            swal({
                title: "Llene todos los campos vacíos",
                text: "",
                icon: imageURL,
                button: "Aceptar",
            });
        }else{
            function isValidEmail(mail) {
                return /^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(mail);
            }
            const inputEmail=document.querySelector(".modalCotizar .ContenerContacto input[name=email]");
            //const inputQuote=document.querySelector(".modalCotizar .description #cantQuote");
            const inputQuote = localStorage["cotizar"];
            if(isValidEmail(inputEmail.value)){
                if(inputQuote != null || inputQuote != 0 || inputQuote != ''){
                    swal({
                        title: "",
                        text: "Espere un momento por favor",
                        icon: imageURL,
                        button: false,
                        closeOnClickOutside: false,
                    });

                    var url = https+"quotesSave";
                    var j = $(".formContacto").serialize();
                    console.log(url);
                    console.log(j);
                    $.post(url, j)
                    .done(function (data) {
                        //alert(data);
                        if(data==1){
                            $(".contador").text(0);
                            swal({
                                title: "Gracias por confiar en nosotros",
                                text: "dentro de poco nos pondremos en contacto",
                                icon: "success",
                                button: "Aceptar",
                            });
                            const productQuote=$($(".modalCotizar")[0].querySelector(".description"));
                            productQuote.html("");
                            const inputName=document.querySelectorAll(".ContenerContacto input[name]");
                            for (let index = 0; index < inputName.length; index++) {
                                const element = inputName[index];
                                $(element).val("");
                            }
                            $('.modalCotizar').modal('close');
                            //vaciar campos de cotizador
                            localStorage["cotizar"]="0";
                            localStorage["product"]="";
                            localStorage["product_id"]="";
                        }else{
                            swal({
                                title: "Sucedió un problema al momento del registro",
                                text: "Inténtelo nuevamente por favor",
                                icon: "warning",
                                button: "Aceptar",
                            });
                        }
                    })
                    .fail(function(err) {
                        console.log(err);
                        swal({
                            title: "Sucedió un problema al momento del registro",
                            text: "Inténtelo nuevamente por favor",
                            icon: "warning",
                            button: "Aceptar",
                        });
                    });
                }else{
                    swal({
                        title: "Agregue por lo menos 1 producto",
                        text: "",
                        icon: imageURL,
                        button: "Aceptar",
                    });
                }
            }else{
                swal({
                    title: "Verifique el correo",
                    text: "",
                    icon: imageURL,
                    button: "Aceptar",
                });
                $(inputEmail).addClass("error");
            }
        }
    });
})
